export default "__VITE_ASSET__DtMrErNT__"